module.exports = __webpack_public_path__ + "3981a7efffeb90981ba8147796b5b5ce.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/fr3.pdf
// module id = 929
// module chunks = 3